import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountryStateCityService {

  private baseUrl = environment.serverAPI4;
  
  private countriesCache$: Observable<any>;
  private statesCache = new Map<string, Observable<any>>();
  private citiesCache = new Map<string, Observable<any>>();

  constructor(private http: HttpClient) { }

  /**
   * Get all countries (basic info)
   */
  getAllCountries(): Observable<any> {
    if (!this.countriesCache$) {
      this.countriesCache$ = this.http.get(`${this.baseUrl}/api/locations/countries`).pipe(shareReplay(1));
    }
    return this.countriesCache$;
  }

  /**
   * Get all countries with states and cities
   */
  getAllCountriesDetailed(): Observable<any> {
    const params = new HttpParams().set('detailed', 'true');
    return this.http.get(`${this.baseUrl}/api/locations/countries`, { params });
  }

  /**
   * Get specific country by ID
   */
  getCountryById(id: string | number): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/locations/countries/${id}`);
  }

  /**
   * Search countries by name
   */
  searchCountries(query: string): Observable<any> {
    const params = new HttpParams().set('query', query);
    return this.http.get(`${this.baseUrl}/api/locations/countries/search`, { params });
  }

  /**
   * Get states for a specific country
   */
  getStatesByCountry(countryId: string | number): Observable<any> {
    const key = countryId.toString();
    if (!this.statesCache.has(key)) {
      this.statesCache.set(key, this.http.get(`${this.baseUrl}/api/locations/countries/${countryId}/states`).pipe(shareReplay(1)));
    }
    return this.statesCache.get(key)!;
  }

  /**
   * Get specific state by ID
   */
  getStateById(countryId: string | number, stateId: string | number): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/locations/countries/${countryId}/states/${stateId}`);
  }

  /**
   * Get cities for a specific state
   */
  getCitiesByState(countryId: string | number, stateId: string | number): Observable<any> {
    const key = `${countryId}-${stateId}`;
    if (!this.citiesCache.has(key)) {
      this.citiesCache.set(key, this.http.get(`${this.baseUrl}/api/locations/countries/${countryId}/states/${stateId}/cities`).pipe(shareReplay(1)));
    }
    return this.citiesCache.get(key)!;
  }
}
